import './modules/polyfills';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './modules/navigation';
import './modules/sliders';
import './modules/filters';
import './modules/announcements';
import './modules/cookies';
import './modules/timeline';
import './modules/load-more';
import './modules/fullscreen-gallery';
import './modules/social-sharing';
import './modules/site-search';
import './modules/opportunities';
import './modules/contact';
import './modules/events';
import './modules/prayer';
import * as Utils from './modules/utils';
import * as LightboxVideos from './modules/lightbox-videos';
import * as Team from './modules/team';
import * as Compass from './modules/compass';
import * as Connections from './modules/connections';
import * as Newsletter from './modules/newsletter';
import * as Enquiries from './modules/enquiries';
import * as BGVideos from './modules/feature-videos';

Utils.buildPage();

// ObjectFit Polyfill
if ('objectFit' in document.documentElement.style === false) {
    objectFitImages();
}

/**
* BG Videos
**/
if (document.querySelectorAll('.js-feature-video').length) {
    BGVideos.init();
}

/**
* Team
**/
if (document.querySelectorAll('.js-team-bio-link').length) {
    Team.init();
}

/**
* Compass Animation
**/
if (document.querySelector('.js-compass')) {
    Compass.init();
}

/**
* Connections
**/
if (document.querySelector('.js-projects-lightbox')) {
    Connections.init();
}

/**
* Newsletter Form
**/
if (document.querySelector('.js-newsletter')) {
    Newsletter.init();
}

/**
* Enquiries Form
**/
if (document.querySelector('.js-enquiries')) {
    Enquiries.init();
}

/**
* Smooth Scroll
**/
if (document.querySelectorAll('.js-scroll-to').length) {
    document.querySelectorAll('.js-scroll-to').forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();
            Utils.autoScrollToTarget(el.hash);
        })
    });
}

// Track anochor clicks so we can fire unload events
Utils.trackAnchorClicks();

window.onYouTubeIframeAPIReady = function () {
    LightboxVideos.init();
};